import { schema } from 'normalizr';

export const banner = new schema.Entity('banners');
export const banners = new schema.Array(banner);

export const scheduledDiscount = new schema.Entity('scheduledDiscounts');
export const scheduledDiscounts = new schema.Array(scheduledDiscount);
